<template>
  <div class="px-0 container is-fluid min-h-90vh" :class="{'container-dashboard-sm': dataTotalReschedule > 0}">
    <SnackbarRescheduleSurvey v-if="dataTotalReschedule > 0" :total="dataTotalReschedule" @buttonClick="showRescheduleSurvey" />
    <title-bar :title-stack="titleStack" class="mb-5 px-5 pt-5 margin-top-transition" :style="{'margin-top': dataTotalReschedule > 0 ? '75px' : '0px'}" />

    <transition name="fade" mode="out-in">
      <div v-if="isLoadingCard" class="performa-harian-wrapper px-5" key="loading-1">
        <CardSkeleton :totalCard="4" />
      </div>
      <div v-else class="performa-harian-wrapper px-5" key="main-1">
      <!-- <div class="performa-harian-wrapper px-5" :class="{'loading-state': isLoadingCard}"> -->
        <p class="averta-bold is-size-4">Performa Hari Ini</p>
        <p>Terakhir Update: ~ {{ convertDate(dataCard && dataCard.last_update) }}</p>

        <div v-if="dataCard" class="columns mt-3">
          <div class="column card col-1 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Konsultan Aktif</p>
              <p class="is-size-4 averta-black my-2">{{ dataCard.daily && dataCard.daily.consultan_active }}</p>
            </div>
          </div>
          <div class="column card col-1 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Survey Berlangsung</p>
              <p class="is-size-4 averta-black my-2">{{ dataCard.daily.survey_in_progress }}</p>
            </div>
          </div>
          <div class="column card col-1 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Survey Selesai</p>
              <p class="is-size-4 averta-black my-2">{{ dataCard.daily.survey_complete }}</p>
            </div>
          </div>
          <div class="column card col-1 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Penawaran Dibuat</p>
              <p class="is-size-4 averta-black my-2">{{ dataCard.daily.offering_created }}</p>
            </div>
          </div>
          <div class="column card col-2 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Target Tercapai</p>
              <div class="is-flex is-align-items-center">
                <p class="is-size-4 averta-black my-2 mr-3">{{ dataCard.daily.target }} %</p>
                <UpIcon :class="{ 'flip-icon': dataCard.daily.target <= 50 }" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div v-if="isLoadingBerlangsung" class="card-penawaran-wrapper px-5 py-3" key="loading-2">
        <CardSkeleton :totalCard="3" height="200px" />
      </div>
      <div v-else-if="dataPenawaran && dataPenawaran.length > 0" class="card-penawaran-wrapper px-5 py-3" key="main-2">
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <div class="mr-2">
            <p class="averta-bold is-size-4">Selesaikan Penawaran</p>
            <p>Segera lengkapi penawaran untuk melanjutkan proses</p>
          </div>
          <p class="text-lihat is-clickable averta-bold label-sm-12 has-text-centered" @click="() => this.$router.push('/am/project')">Lihat Semua</p>
        </div>

        <div class="columns mt-3 parrent-list pb-3">
          <div class="column card list-penawaran is-4 p-5 m-2 is-clickable is-flex is-flex-direction-column"
            @click="goToProject(data.survey_id)" v-for="data, index in dataPenawaran" :key="`${data.id}-offering-${index}`">
            <div class="columns card-atas pb-2 is-flex-grow-1 mb-0">
              <div class="column pb-0 pt-1 px-1 is-flex">
                <div>
                  <p>{{ data.survey_complain_code ? data.survey_complain_code : data.survey_id }}</p>
                  <p class="store averta-bold">{{ data.store.name }}</p>
                </div>
                <div class="column has-text-right p-0 mt-1">
                  <span class="p-1 status-penawaran white-space-nowrap p-2 averta-bold" :class="getClassName(data.status)">{{ wordingMenu(data.status) }}</span>
                </div>
              </div>
              <div class="column pb-0 pt-1">
                <div class="is-flex is-justify-content-flex-end">
                  <div class="mr-2 wrap-logo is-flex is-align-items-center is-align-items-center">
                    <img :src="data.vendor.logo" :alt="data.vendor.name">
                  </div>
                  <p class="averta-bold has-text-right">{{ data.vendor.name }}</p>
                </div>
              </div>
            </div>

            <svg width="100%" height="10">
              <line x1="0" y1="5" x2="100%" y2="5" stroke="#868686" stroke-width="1" stroke-dasharray="10,5" />
            </svg>

            <div class="columns is-flex card-bawah mt-4">
              <div class="column pb-0-mobile">
                <div class="border-right-card">
                  <p class="mb-0 color-grey">Tgl Survey Selesai</p>
                  <p class="averta-bold">{{ convertDate(data.survey_date) }}</p>
                </div>
              </div>
              <div class="column">
                <p class="mb-0 color-grey">Tgl Pembuatan Penawaran</p>
                <p class="averta-bold">{{ convertDate(data.created_at) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div v-if="isLoadingCard" class="px-5 mb-6 mt-3" key="loading-3">
        <CardSkeleton :totalCard="4" height="200px" />
      </div>
      <div v-else class="px-5 mb-6 mt-3" key="main-3">
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          <p class="averta-bold is-size-4">Performa Bulanan</p>
          <b-dropdown aria-role="list" v-model="selectedMonth">
            <template #trigger="{ active }">
              <b-button :label="selectedMonth ? selectedMonth.month : 'Pilih Bulan'"
                :icon-right="active ? 'menu-up' : 'menu-down'" />
            </template>

            <b-dropdown-item aria-role="listitem" v-for="data in listMonth" :key="`${data.value}-month`" :value="data"
              @click="performaBulanan()">
              {{ data.month }}
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div v-if="dataCard" class="columns mt-3">
          <div class="column card col-month-1 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Penawaran Disetujui Client</p>
              <p class="is-size-2 averta-bold my-2">{{ dataCard.monthly.offering_approved }}</p>
              <hr />
              <a class="bottom-card" @click="() => this.$router.push('/am/project')">
                <span class="mr-2 averta-bold">Selengkapnya</span>
                <ArrowRightIcon />
              </a>
            </div>
          </div>
          <div class="column card col-month-2 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Proyek Berjalan</p>
              <p class="is-size-2 averta-bold my-2">{{ dataCard.monthly.project_active }}</p>
              <hr />
              <a class="bottom-card" @click="() => this.$router.push('/am/project')">
                <span class="mr-2 averta-bold">Selengkapnya</span>
                <ArrowRightIcon />
              </a>
            </div>
          </div>
          <div class="column card col-month-3 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Proyek Selesai</p>
              <p class="is-size-2 averta-bold my-2">{{ dataCard.monthly.project_complete }}</p>
              <hr />
              <a class="bottom-card" @click="() => this.$router.push('/am/project')">
                <span class="mr-2 averta-bold">Selengkapnya</span>
                <ArrowRightIcon />
              </a>
            </div>
          </div>
          <div class="column card col-month-4 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Proyek Lunas</p>
              <p class="is-size-2 averta-bold my-2">{{ dataCard.monthly.project_paid }}</p>
              <hr />
              <a class="bottom-card" @click="() => this.$router.push('/am/project')">
                <span class="mr-2 averta-bold">Selengkapnya</span>
                <ArrowRightIcon />
              </a>
            </div>
          </div>
          <div class="column card col-month-5 p-3 m-2">
            <img :src="require('@/assets/img/wave-card.png')" alt="wave" class="wave" />
            <div class="card-body-proyek">
              <p class="is-size-5 averta-bold">Total Belum Bayar</p>
              <p class="is-size-2 averta-bold my-2">{{ formatThousand(dataCard.monthly.total_not_paid) }}</p>
              <hr />
              <a class="bottom-card" @click="() => this.$router.push('/am/project')">
                <span class="mr-2 averta-bold">Selengkapnya</span>
                <ArrowRightIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Reschedule Survey -->
    <ModalRescheduleSurvey :showModal="modalRescheduleSurvey" width="75vw" @closeModal="showRescheduleSurvey" @totalReschedule="totalReschedule($event)" :isDashboard="true"/>

  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import TitleBar from '@/components/TitleBar'
import CardSkeleton from '@/components/skeleton/CardSkeleton'
import firsLoginImage from '@/assets/img/firs-login.png'
import { UpIcon, ArrowRightIcon } from '@/components/icons'
import { formatCurrency, wordingMenuHelper, getStatusClassName } from '@/helpers'
import SnackbarRescheduleSurvey from '@/components/snackbar/SnackbarRescheduleSurvey.vue'
import ModalRescheduleSurvey from '@/components/modal/ModalRescheduleSurvey.vue'

export default {
  name: 'DashboardAM',
  components: {
    TitleBar,
    CardSkeleton,
    UpIcon,
    ArrowRightIcon,
    SnackbarRescheduleSurvey,
    ModalRescheduleSurvey
  },
  computed: {
    titleStack () {
      return ['Dashboard']
    },
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user',
      firstLogin: 'auth/firstLogin'
    })
  },
  data () {
    return {
      isLoadingCard: true,
      isLoadingBerlangsung: true,
      dataCard: null,
      dataPenawaran: [],
      selectedMonth: null,
      listMonth: [],
      modalRescheduleSurvey: false,
      dataTotalReschedule: null
    }
  },
  methods: {
    formatThousand (x) {
      return formatCurrency(x)
    },
    goToProject (id) {
      this.$router.push(`/am/project/survey/${id}/detail`)
    },
    convertDate (date) {
      if (date === null) {
        return ''
      }
      return moment(date).format('DD MMMM YYYY')
    },
    getDataCard (payload) {
      this.isLoadingCard = true
      this.$store
        .dispatch('dashboard/getCardDashboard', payload)
        .then(response => {
          this.dataCard = response.data.data
          this.isLoadingCard = false
        })
        .catch(error => {
          this.isLoadingCard = false
          console.log(error)
        })
    },
    getSurveyBerlangsung () {
      this.isLoadingBerlangsung = true
      const payload = {
        url: this.url
        // page: 1
      }

      this.$store
        .dispatch('project/getListPenawaranDashboard', payload)
        .then(response => {
          this.dataPenawaran = response.data.data.list
          this.isLoadingBerlangsung = false
        })
        .catch(error => {
          this.isLoadingBerlangsung = false
          console.log(error)
        })
    },
    performaBulanan () {
      const data = {
        start_date: moment(this.selectedMonth.value).startOf('month').format('YYYY-MM-DD'),
        end_date: moment(this.selectedMonth.value).endOf('month').format('YYYY-MM-DD')
      }

      const payload = {
        ...data,
        url: this.url
      }

      this.getDataCard(payload)
    },
    generateMonth () {
      for (let month = 0; month <= 11; month++) {
        const temp = {
          month: moment().month(month).format('MMMM YYYY'),
          value: moment().month(month).format('YYYY-MM')
        }
        this.listMonth.push(temp)
      }
    },
    showRescheduleSurvey () {
      this.modalRescheduleSurvey = !this.modalRescheduleSurvey
    },
    totalReschedule (data) {
      this.dataTotalReschedule = data
    },
    getClassName (status) {
      return getStatusClassName(status)
    },
    wordingMenu (value) {
      return wordingMenuHelper(value)
    }
  },
  created () {
    const payload = { url: this.url }
    this.getDataCard(payload)
    this.getSurveyBerlangsung()
    this.generateMonth()
  },
  mounted () {
    if (this.firstLogin) {
      this.$swal({
        imageUrl: firsLoginImage,
        imageAlt: 'first login image',
        width: '600px',
        padding: '10px 10px 30px 10px',
        title: `<p class="averta-bold label-22">Hallo! ${this.user.name}</p>`,
        html: '<p>Selamat datang di Dashboard Business Support</p>',
        confirmButtonText: 'Mulai',
        confirmButtonColor: '#EB4600',
        customClass: {
          confirmButton: 'btn-first-login'
        }
      }).then(() => {
        this.$store.commit('auth/setFirstLogin', false)
      })
    }

    document.documentElement.classList.remove('has-aside-left')
    document.documentElement.classList.remove('has-navbar-fixed-top')
  }
}
</script>

<style scoped lang="scss">
.performa-harian-wrapper {
  margin-bottom: 30px;
  opacity: 1;
  transition: 0.3s opacity ease-in-out;

  &.loading-state {
    opacity: 0;
    height: 0;
  }
}

.card-body-proyek {
  z-index: 1;
  position: relative;
}

.text-lihat {
  background: linear-gradient(116.12deg, #D9272D 16.15%, #EB4600 83.24%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.wave {
  object-fit: cover;
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
  left: 0;
  border-radius: 20px;
}

.col-1 {
  background: linear-gradient(90deg, #751ce6 0%, #552bff 100%);
  border-radius: 20px;
  color: white;
}

.col-2 {
  background: linear-gradient(116.12deg, #1ede31 16.15%, #72de1e 83.24%);
  border-radius: 20px;
  color: white;
}

.flip-icon {
  transform: rotate(-180deg);
}

.card-penawaran-wrapper {
  background: #FAFAFA;
}

.parrent-list {
  overflow-x: auto;
}

.list-penawaran {
  background: white;
  border-radius: 20px;
  border: 1px solid #E1E1E1;
}

.store {
  color: #D9272D;
}

.status-penawaran {
  border-radius: 20px;
  color: white;
  font-size: 12px;
}

.card-atas {
  flex-direction: column;
}

.card-bawah {
  background: linear-gradient(90deg, rgba(255, 221, 221, 0.4) 0%, rgba(255, 239, 219, 0.4) 99.97%);
  border-radius: 12px;
}

.border-right-card {
  border-right: 1px solid #b4b4b4;
  padding-right: 0 !important;
}

.col-month-1 {
  background: linear-gradient(90deg, #3185FC 0%, #31B3FC 100%);
  border-radius: 20px;
  color: white;
}

.col-month-2 {
  background: linear-gradient(90deg, #FFA200 0%, #F5BB54 100%);
  border-radius: 20px;
  color: white;
}

.col-month-3 {
  background: linear-gradient(90deg, #10BD41 0%, #55F883 100%);
  border-radius: 20px;
  color: white;
}

.col-month-4 {
  background: linear-gradient(90deg, #EB4600 0%, #FF8C5B 100%);
  border-radius: 20px;
  color: white;
}

.col-month-5 {
  background: linear-gradient(90deg, #ED4949 0%, #A40707 100%);
  border-radius: 20px;
  color: white;
}

.bottom-card {
  display: flex;
  justify-content: end;
  align-items: center;
  color: white;
  z-index: 1;
}

.bottom-card svg {
  fill: white;
}

.wrap-logo img {
  height: 30px;
  object-fit: contain;
}

.svg-border {
  height: 100%;
}

.margin-top-transition {
  margin-top: 0;
  transition: 0.3s margin-top ease-in-out;
}

@media only screen and (max-width: 767px) {
  .container-dashboard-sm {
    margin-top: 9em !important;
  }

  .pb-0-mobile {
    padding-bottom: 0 !important;
  }

  .pt-0-mobile {
    padding-top: 0 !important;
  }

  .border-right-card {
    border: none;
  }
}

</style>
